import axios, { AxiosRequestConfig } from 'axios';
const axiosInstance = axios.create({
  baseURL: 'https://templates100.blob.core.windows.net/list/',
  timeout: 1000,
  // headers: { 'X-Custom-Header': 'foobar' },
});
export const makeRequest = async <T>(config: AxiosRequestConfig) => axiosInstance.request<T>(config);
